import Svg, { SvgProps, Path } from 'react-native-svg';

export const CloseIcon = (props: SvgProps) => (
  <Svg viewBox="0 0 24 24" width={24} height={24} fill="#FFFFFF" {...props}>
    <Path d="M4.578 3.156 3.156 4.578l7.922 7.922-7.969 7.984 1.407 1.407 7.984-7.97 7.969 7.97 1.422-1.422-7.97-7.969 7.923-7.922-1.422-1.422-7.922 7.922-7.922-7.922Z" />
  </Svg>
);
